import { render } from "./best-carousel.vue?vue&type=template&id=3e3ce0f1"
import script from "./best-carousel.vue?vue&type=script&lang=js"
export * from "./best-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__